module.exports = __webpack_public_path__ + "img/website-icon.5ba6b071.png";